import React from "react";
import {Col, Row, Spinner} from "react-bootstrap";

const Loader = (): JSX.Element => {
    return (
        <Row className="justify-content-center">
            <Col>
                <Spinner animation="grow"/>
            </Col>
        </Row>
    );
}

export default Loader;